// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"103":"bc2d6f15","306":"c4ce9856"}[chunkId] + ".chunk.css";
};